// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.edit_dashboard__XFUIy {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.edit_dashboardContain__yQ2cD {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.edit_bodythemedark__0LHjt .edit_dashboardContain__yQ2cD,
.edit_bodythemedark__0LHjt .edit_dashboard__XFUIy,
.edit_bodythemedark__0LHjt .edit_cont2__FVTrO {
  background-Color: #0f1824;
}

.edit_top_header__bdkVV .edit_top_header_inner__bXGSL {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.edit_cont2__FVTrO {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.edit_subLink__-5pVR svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.edit_footer__HLOZE {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.edit_bodythemelight__q5mLJ {
  background-color: #fff;
  padding-top: 90px;
}

.edit_bodythemedark__0LHjt {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.edit_headerthemelight__WUo4J {
  background-color: #fff;
}

.edit_headerthemedark__nV12j {
  background-color: #132337;
}

.edit_top_header__bdkVV {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.edit_menuthemelight__UlCgS {
  background-color: #fff;
}

.edit_menuthemedark__c5mml {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.edit_menulinklight__v\\+chl span {
  color: #666666 !important;
}

.edit_menulinklight__v\\+chl a {
  color: #CBCBCB !important;
}

.edit_menulinklight__v\\+chl:hover span, .edit_menulinklight__v\\+chl:hover a {
  color: #fff !important;
}

.edit_menulinkdarkSelected__ySgsR {
  background-color: #1c2e45;
  color: #fff;
}

.edit_menuthemelight__UlCgS .edit_menulinklightSelected__nwgnU {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.edit_menulinkdark__e\\+3iY {
  color: #60677e !important;
}

.edit_menulinklight__v\\+chl:hover {
  color: #fff !important;
  background-color: #205440;
}

.edit_menulinkdark__e\\+3iY:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.edit_headinglight__RHQVI {
  color: #60677e;
}

.edit_headingdark__Adcis {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.edit_searchboxlight__2HGJ9 {
  background-color: #fff;
  border: none;
}

.edit_searchboxdark__4vEKI {
  background-color: #132337;
  color: #fff;
  border: none;
}

.edit_searchboxdark__4vEKI::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.edit_tableheadlight__bJyAN {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.edit_tableheadlight__bJyAN th {
  color: #fff;
}

thead .edit_tableheadlight__bJyAN th:first-child,
thead .edit_tableheaddark__q0qCR th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .edit_tableheadlight__bJyAN th:last-child,
thead .edit_tableheaddark__q0qCR th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.edit_table__-qogP.edit_table-borderless__L48Ri {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.edit_tableheaddark__q0qCR {
  background-color: #1e1e2d;
  color: #fff;
}

.edit_table-borderless__L48Ri tr:nth-child(even) {
  background-color: #F9FAFB;
}

.edit_table-borderless__L48Ri .edit_left-section__DvxgR {
  padding-top: 10px;
}

.edit_tablebodylight__zzua1 td,
.edit_tablebodydark__Asv9G td {
  padding: 1rem 1rem !important;
}

.edit_tablebodylight__zzua1 {
  background-color: #fff;
}
.edit_tablebodylight__zzua1:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.edit_tablebodydark__Asv9G {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.edit_tablebodydark__Asv9G:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.edit_paginationlight__UsHRc {
  color: #60677e !important;
  font-size: 13px !important;
}

.edit_paginationdark__Ve4s5 {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.edit_formthemelight__1srUw {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.edit_formthemedark__NIUi5 {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.edit_formthemedark__NIUi5 ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.edit_viewformlight__z8N9A {
  background-color: #f3f6f9;
}

.edit_permissionboxlight__zacXR {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.edit_permissionboxdark__kCVOv {
  background-color: #151521;
  border: solid 1px #242434;
}

.edit_errormsgclr__vqhkc {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.edit_graphclrlight__17YTi {
  background-color: #fff;
}

.edit_graphclrdark__GQK9A {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#edit_card1bglight__uISux {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#edit_card1bglight__uISux:hover {
  background: #f7fffc;
}

#edit_card1bgdark__s5ViH {
  background: #392f28;
}

#edit_card1bgdark__s5ViH:hover {
  background: #f7fffc;
}

#edit_card2bglight__qWy0- {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#edit_card2bglight__qWy0-:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#edit_card2bgdark__9eIJP {
  background: #1c3238;
}

#edit_card3bglight__i8MQs {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#edit_card3bglight__i8MQs:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#edit_card3bgdark__UI-WU {
  background: #3a2434;
}

#edit_card4bglight__MDS-U {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#edit_card4bglight__MDS-U:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#edit_card4bgdark__HPvid {
  background: #2f264f;
}

#edit_card1bgdark__s5ViH a, #edit_card1bgdark__s5ViH p,
#edit_card2bgdark__9eIJP a, #edit_card2bgdark__9eIJP p,
#edit_card3bgdark__UI-WU a, #edit_card3bgdark__UI-WU p,
#edit_card4bgdark__HPvid a, #edit_card4bgdark__HPvid p {
  color: #fff;
}

/* 
Action button theme
*/
.edit_actionbtnlight__wqx85 {
  color: rgba(70, 71, 91, 0.8705882353);
}

.edit_actionbtndark__DIeWX {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.edit_profiledropdownlight__vMEbz {
  background-color: #fff;
}

.edit_profiledropdowndark__hamPR {
  background-color: #151521;
}

.edit_settingsection__ulggD #edit_addform__VzIZa.edit_formthemedark__NIUi5 .edit_savebtn__CSqa6 {
  background-color: #0a2574;
  color: #fff;
}

#edit_addform__VzIZa.edit_formthemedark__NIUi5 .edit_savebtn__CSqa6 {
  background-color: #0a2574;
  color: #fff;
}

.edit_profile_conatiner__SA5tk {
  border-radius: 5px !important;
}

.edit_bodythemedark__0LHjt .edit_ag-theme-alpine__Dnnj7 .edit_ag-row__tO\\+na {
  background: #000 !important;
}

.edit_bodythemedark__0LHjt .edit_formbtn__NVKT0 {
  background-color: #0a2574;
}

.edit_bodythemedark__0LHjt .edit_resetbtn__DV\\+5m {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.edit_bodythemedark__0LHjt .edit_resetbtn__DV\\+5m:hover {
  background-color: #0a2574;
}

.edit_headingdark__Adcis span {
  background-color: #132337;
}

.edit_resetbtn__DV\\+5m {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.edit_resetbtn__DV\\+5m:hover,
.edit_resetbtn__DV\\+5m:active,
.edit_resetbtn__DV\\+5m:focus {
  background-color: #205440;
  color: #fff;
}

.edit_addBtn__fWQ-T {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.edit_addBtn__fWQ-T svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.edit_addBtn__fWQ-T:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.edit_cust_addBtn__ZhtvT.edit_addBtn__fWQ-T svg {
  top: 2px;
}

.edit_deleteBtn__avVJ9 {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.edit_deleteBtn__avVJ9 {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.edit_deleteBtn__avVJ9:active, .edit_deleteBtn__avVJ9:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.edit_deleteBtn__avVJ9 svg {
  position: relative;
  top: -2px;
}

.edit_deleteBtn__avVJ9:hover,
.edit_deleteBtn__avVJ9:active,
.edit_deleteBtn__avVJ9:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.edit_confirmBtn__xvKFZ {
  background-color: #205440;
}

.edit_confirmBtn__xvKFZ:hover,
.edit_confirmBtn__xvKFZ:active,
.edit_confirmBtn__xvKFZ:focus {
  background-color: #205440;
}

.edit_confirmBtn__xvKFZ svg {
  top: 0;
}

.edit_back_dlt__EjmoS {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.edit_delPopContainer__9mlmD .edit_modal-body__i4h\\+v {
  padding: 25px;
  text-align: center;
}

.edit_delPopContainer__9mlmD .edit_delet_icon__Ksaf5 {
  margin-bottom: 11px;
}

.edit_delPopContainer__9mlmD p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.edit_arrowback__M6cUh svg {
  fill: #000;
}

.edit_bodythemedark__0LHjt .edit_arrowback__M6cUh {
  background-color: #0a2574;
  color: #fff;
}

.edit_bodythemedark__0LHjt .edit_arrowback__M6cUh svg {
  fill: #fff;
}

.edit_bodythemedark__0LHjt .edit_drpdwn_btn__GvA4W {
  background-color: #132337;
}

.edit_bodythemedark__0LHjt .edit_empname__X95KO {
  color: #60677e !important;
}

.edit_bodythemedark__0LHjt .edit_navitemli__KOZiS a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.edit_bodythemedark__0LHjt .edit_tabnavli__\\+V862 a.edit_settingsgeneral__oIHHr,
.edit_bodythemedark__0LHjt .edit_tabnavli__\\+V862 a.edit_settingslinks__iqJ3D:hover {
  background-color: #0a2574;
  color: #fff;
}

.edit_bodythemedark__0LHjt .edit_tabnavli__\\+V862 a.edit_settingslinks__iqJ3D {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .edit_tableheadlight__bJyAN th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .edit_dashboard__XFUIy {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #edit_dashboardcont2__\\+ULH1 {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .edit_sectionright__RFXF1 {
    float: unset !important;
  }
  .edit_dashboard__XFUIy {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .edit_cont2__FVTrO {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .edit_bodythemelight__q5mLJ, .edit_bodythemedark__0LHjt {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .edit_exer_modal_contain__roWXG .edit_modal-dialog__8nwZJ {
    max-width: 1055px;
  }
  .edit_delPopContainer__9mlmD .edit_modal-dialog__8nwZJ {
    max-width: 350px;
  }
}
#edit_addform__VzIZa {
  width: 100%;
  border-radius: 5px;
  margin-top: 30px;
}
#edit_addform__VzIZa .edit_permission_title__2o43i {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
#edit_addform__VzIZa #edit_addheading__m\\+O2r {
  font-size: 14px;
  margin-bottom: 0px;
  margin-left: 5px;
}
#edit_addform__VzIZa .edit_inputbox__1Vzn\\+ {
  padding: 4px 5px 8px 10px;
  border-radius: 5px;
  width: 100%;
  border: 1px solid #ced4da;
  color: #1d1d1d;
  font-size: 14px;
}
#edit_addform__VzIZa .edit_inputbox1__Sdh2j {
  padding: 4px 5px 8px 10px;
  border: none;
  border-radius: 5px;
  width: 100%;
  background-color: #151521;
  color: #60677e;
}
#edit_addform__VzIZa .edit_formlabel__5oDNG {
  font-size: 14px;
}
#edit_addform__VzIZa .edit_formbtn__NVKT0 {
  background-color: #205440;
  color: white;
  border: none;
  width: 100px;
  font-size: 16px;
  padding: 11px;
  border-radius: 5px;
}
#edit_addform__VzIZa .edit_formbtn__NVKT0:hover {
  background-color: rgba(37, 105, 109, 0.864);
}
#edit_addform__VzIZa .edit_arrowback__M6cUh {
  float: right;
  background-color: #dde2eb;
  padding: 10px;
  color: #205440;
  cursor: pointer;
  border-radius: 3px;
}
#edit_addform__VzIZa .edit_arrowback__M6cUh:hover {
  background-color: #205440;
  color: #fff;
}
#edit_addform__VzIZa ::placeholder {
  font-size: 12px;
}
#edit_addform__VzIZa ul {
  padding-left: 0px;
  display: flex;
  margin-bottom: 0;
}
#edit_addform__VzIZa ul li {
  list-style: none;
  width: 150px;
}
#edit_addform__VzIZa .edit_selectlabel__679jd {
  margin-left: 5px;
  font-size: 14px;
  text-transform: capitalize;
  vertical-align: middle;
}
#edit_addform__VzIZa #edit_permissionbox__ZXNKa {
  padding: 10px;
  margin-bottom: 20px;
  border-radius: 5px;
}

@media only screen and (max-width: 878px) {
  #edit_addform__VzIZa ul {
    display: list-item !important;
    list-style: none;
  }
}
@media only screen and (max-width: 600px) {
  #edit_dashboardcont2__\\+ULH1 {
    width: calc(100% - 50px);
    left: 50px;
    position: relative;
    padding: 30px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/pages/roles/edit.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAjpBA;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;AAkpBJ;AAhpBI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AAkpBR;AA9oBI;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;AAgpBR;AA7oBI;EACI,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,cDuBM;ECtBN,eAAA;AA+oBR;AA7oBI;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,yBDYS;ECXT,cDgBS;AC+nBjB;AA5oBI;EAEI,eAAA;AA6oBR;AA3oBI;EACI,yBDkBW;ECjBX,YAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AA6oBR;AA3oBQ;EACI,2CDUS;ACmoBrB;AA1oBI;EACI,YAAA;EACA,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AA4oBR;AA1oBU;EACE,yBAAA;EACA,WAAA;AA4oBZ;AAxoBI;EACI,eAAA;AA0oBR;AAtoBI;EACI,iBAAA;EACA,aAAA;EACA,gBAAA;AAwoBR;AAtoBU;EACI,gBAAA;EACA,YAAA;AAwoBd;AApoBM;EACI,gBAAA;EAEA,eAAA;EACA,0BAAA;EACA,sBAAA;AAqoBV;AAloBI;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAooBR;;AA9nBE;EAEM;IACI,6BAAA;IACA,gBAAA;EAgoBV;AACF;AA3nBE;EACE;IACI,wBDpCI;ICqCJ,UDpCG;ICqCH,kBAAA;IACA,aD5CW;ECyqBjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n\n#addform{\n\n    width: 100%;\n    border-radius: 5px;\n    margin-top: 30px;\n\n    .permission_title{\n        display: flex;\n        align-items: center;\n        margin-bottom: 10px;\n    }\n\n\n    #addheading{\n        font-size: 14px;\n        margin-bottom: 0px;\n        margin-left: 5px;\n    }\n\n    .inputbox{\n        padding: 4px 5px 8px 10px;\n        border-radius: 5px;\n        width: 100%;\n        border: 1px solid #ced4da;\n        color: $black-color;\n        font-size: 14px;\n    }\n    .inputbox1{\n        padding: 4px 5px 8px 10px;\n        border: none;\n        border-radius: 5px;\n        width: 100%;\n        background-color: $darkthemecolor;\n        color: $lightthemetext;\n         \n    }\n    .formlabel{\n         \n        font-size: 14px;\n    }\n    .formbtn{\n        background-color: $primary-btncolor;\n        color: white;\n        border: none;\n        width: 100px;\n        font-size: 16px;\n        padding: 11px;\n        border-radius: 5px;\n\n        &:hover{\n            background-color: $secondary-btncolor;\n        }\n    }\n    .arrowback{\n        float: right;\n        background-color: #dde2eb;\n        padding: 10px;\n        color: #205440;\n        cursor: pointer;\n        border-radius: 3px;\n\n          &:hover{\n            background-color: #205440;\n            color: #fff;\n          }\n      }\n    \n    ::placeholder{\n        font-size: 12px;\n    }\n\n    \n    ul{\n        padding-left: 0px;\n        display: flex;\n        margin-bottom: 0;\n\n          li{\n              list-style: none;\n              width: 150px;\n          }\n      } \n  \n      .selectlabel{\n          margin-left: 5px;\n           \n          font-size: 14px;\n          text-transform: capitalize;\n          vertical-align: middle;\n      }\n\n    #permissionbox{\n        padding: 10px;\n        margin-bottom: 20px;\n        border-radius: 5px;\n    }\n\n  }\n  \n\n  @media only screen and (max-width: 878px) {\n    #addform{\n        ul {\n            display: list-item !important;\n            list-style: none;\n        }\n    }\n  }\n\n\n  @media only screen and (max-width: 600px) {\n    #dashboardcont2{\n        width: $dashwidth;\n        left: $dashleft;\n        position: relative;\n        padding: $dashboardpadding;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `edit_dashboard__XFUIy`,
	"dashboardContain": `edit_dashboardContain__yQ2cD`,
	"bodythemedark": `edit_bodythemedark__0LHjt`,
	"cont2": `edit_cont2__FVTrO`,
	"top_header": `edit_top_header__bdkVV`,
	"top_header_inner": `edit_top_header_inner__bXGSL`,
	"subLink": `edit_subLink__-5pVR`,
	"footer": `edit_footer__HLOZE`,
	"bodythemelight": `edit_bodythemelight__q5mLJ`,
	"headerthemelight": `edit_headerthemelight__WUo4J`,
	"headerthemedark": `edit_headerthemedark__nV12j`,
	"menuthemelight": `edit_menuthemelight__UlCgS`,
	"menuthemedark": `edit_menuthemedark__c5mml`,
	"menulinklight": `edit_menulinklight__v+chl`,
	"menulinkdarkSelected": `edit_menulinkdarkSelected__ySgsR`,
	"menulinklightSelected": `edit_menulinklightSelected__nwgnU`,
	"menulinkdark": `edit_menulinkdark__e+3iY`,
	"headinglight": `edit_headinglight__RHQVI`,
	"headingdark": `edit_headingdark__Adcis`,
	"searchboxlight": `edit_searchboxlight__2HGJ9`,
	"searchboxdark": `edit_searchboxdark__4vEKI`,
	"tableheadlight": `edit_tableheadlight__bJyAN`,
	"tableheaddark": `edit_tableheaddark__q0qCR`,
	"table": `edit_table__-qogP`,
	"table-borderless": `edit_table-borderless__L48Ri`,
	"left-section": `edit_left-section__DvxgR`,
	"tablebodylight": `edit_tablebodylight__zzua1`,
	"tablebodydark": `edit_tablebodydark__Asv9G`,
	"paginationlight": `edit_paginationlight__UsHRc`,
	"paginationdark": `edit_paginationdark__Ve4s5`,
	"formthemelight": `edit_formthemelight__1srUw`,
	"formthemedark": `edit_formthemedark__NIUi5`,
	"viewformlight": `edit_viewformlight__z8N9A`,
	"permissionboxlight": `edit_permissionboxlight__zacXR`,
	"permissionboxdark": `edit_permissionboxdark__kCVOv`,
	"errormsgclr": `edit_errormsgclr__vqhkc`,
	"graphclrlight": `edit_graphclrlight__17YTi`,
	"graphclrdark": `edit_graphclrdark__GQK9A`,
	"card1bglight": `edit_card1bglight__uISux`,
	"card1bgdark": `edit_card1bgdark__s5ViH`,
	"card2bglight": `edit_card2bglight__qWy0-`,
	"card2bgdark": `edit_card2bgdark__9eIJP`,
	"card3bglight": `edit_card3bglight__i8MQs`,
	"card3bgdark": `edit_card3bgdark__UI-WU`,
	"card4bglight": `edit_card4bglight__MDS-U`,
	"card4bgdark": `edit_card4bgdark__HPvid`,
	"actionbtnlight": `edit_actionbtnlight__wqx85`,
	"actionbtndark": `edit_actionbtndark__DIeWX`,
	"profiledropdownlight": `edit_profiledropdownlight__vMEbz`,
	"profiledropdowndark": `edit_profiledropdowndark__hamPR`,
	"settingsection": `edit_settingsection__ulggD`,
	"addform": `edit_addform__VzIZa`,
	"savebtn": `edit_savebtn__CSqa6`,
	"profile_conatiner": `edit_profile_conatiner__SA5tk`,
	"ag-theme-alpine": `edit_ag-theme-alpine__Dnnj7`,
	"ag-row": `edit_ag-row__tO+na`,
	"formbtn": `edit_formbtn__NVKT0`,
	"resetbtn": `edit_resetbtn__DV+5m`,
	"addBtn": `edit_addBtn__fWQ-T`,
	"cust_addBtn": `edit_cust_addBtn__ZhtvT`,
	"deleteBtn": `edit_deleteBtn__avVJ9`,
	"confirmBtn": `edit_confirmBtn__xvKFZ`,
	"back_dlt": `edit_back_dlt__EjmoS`,
	"delPopContainer": `edit_delPopContainer__9mlmD`,
	"modal-body": `edit_modal-body__i4h+v`,
	"delet_icon": `edit_delet_icon__Ksaf5`,
	"arrowback": `edit_arrowback__M6cUh`,
	"drpdwn_btn": `edit_drpdwn_btn__GvA4W`,
	"empname": `edit_empname__X95KO`,
	"navitemli": `edit_navitemli__KOZiS`,
	"tabnavli": `edit_tabnavli__+V862`,
	"settingsgeneral": `edit_settingsgeneral__oIHHr`,
	"settingslinks": `edit_settingslinks__iqJ3D`,
	"dashboardcont2": `edit_dashboardcont2__+ULH1`,
	"sectionright": `edit_sectionright__RFXF1`,
	"exer_modal_contain": `edit_exer_modal_contain__roWXG`,
	"modal-dialog": `edit_modal-dialog__8nwZJ`,
	"permission_title": `edit_permission_title__2o43i`,
	"addheading": `edit_addheading__m+O2r`,
	"inputbox": `edit_inputbox__1Vzn+`,
	"inputbox1": `edit_inputbox1__Sdh2j`,
	"formlabel": `edit_formlabel__5oDNG`,
	"selectlabel": `edit_selectlabel__679jd`,
	"permissionbox": `edit_permissionbox__ZXNKa`
};
export default ___CSS_LOADER_EXPORT___;
